import React from "react";
import "./FAQ.css";
import Question from "../Question/Question";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLink, faPhone } from "@fortawesome/free-solid-svg-icons";

function FAQ() {
  return (
    <section id="faq">
      <div className="row faq__row">
        <h3 className="faq__subtitle">FREQUENTLY ASKED QUESTIONS</h3>
        <div className="faq__container">
          <Question
            title={"What is life coaching? And how does it work?"}
            para={
              <>
                Life coaching is about empowering you to create a fulfilling life. As your coach, I’ll help you understand your values, strengths, and direction.<br></br><br></br>
                Expect powerful conversations where we assess your current situation, clarify your desires, and set inspiring goals. My style is personalised and holistic, addressing all aspects of your life—from routines and relationships to mindset and motivation. I focus not just on long-term dreams but also on achievable milestones to guide your journey step by step.
              </>
            }
          />
          <Question
            title={"What is peer mentoring?"}
            para={
              <>
               Peer mentoring is grounded in lived experience. It’s about walking beside you—not above you—as you navigate life’s challenges. I offer practical support, emotional insight, and real-world strategies drawn from my own journey. Whether you're building confidence, adjusting to change, or just need someone who truly gets it, peer mentoring creates space for growth, clarity, and connection.
              </>
            }
          />
        
          <Question
            title={"Is a life coach the same as a counsellor?"}
            para={
              <>
                Life coaches focus on accountability and future-oriented guidance, helping clients achieve their goals. Counsellors, on the other hand, address past issues, treat mental illness, addictions, and trauma. While life coaching may touch on the past for insight, our main priority is the present and future.<br></br><br></br>
Peer mentoring sits somewhere in between—offering support through shared experience, without diagnosing or treating. It’s about being real, relatable, and resourceful.
              </>
            }
          />
          <Question
            title={"What should I expect during our sessions?"}
            para={
              <>
                Imagine having a cup of tea with someone who’s walked a similar path and genuinely wants to help. That’s what our sessions will feel like.<br></br><br></br>
I’m here to support you, offer guidance, and help you see things from a new angle. Together, we’ll work on your goals and make sure you’re moving forward in the right direction—whether through coaching, mentoring, or a blend of both.
              </>
            }
          />
          <Question
            title={"What sets me apart from other life coaches?"}
            para={
              <>
              don't believe in sugarcoating things—I'm here to challenge you in the best way possible. My style is honest, straightforward, and grounded in real-life experience. I’ve lived through the ups and downs, and I bring that depth into every session.<br></br><br></br>
              Think of me as a supportive friend who isn’t afraid to tell it like it is. I keep our conversations real and authentic, encouraging you to embrace your true self too.
              </>
            }
          />
          <Question
            title={"How long does coaching or mentoring typically last?"}
            para={
              <>
             We’ll start with a single 60-minute session. For some clients, that’s enough. Others choose a longer journey.<br></br><br></br>
             I offer extended sessions (2 hours or more) for deeper exploration and support. Most clients find that a coaching or mentoring program spanning 3 to 12 months suits their needs best—but it’s always flexible and tailored to you.
              </>
            }
          />
        </div>
      </div>
    </section>
  );
}

export default FAQ;
